import ShopifySettings from '@/modules/integrations/types/shopify/ShopifySettings'
import ShopifyOverview from '@/modules/integrations/types/shopify/ShopifyOverview'
import ConnectionStep from '@/modules/integrations/types/shopify/ConnectionStep'
import EventsStep from '@/modules/integrations/types/shopify/EventsStep'
import MappingStep from '@/modules/integrations/types/shopify/MappingStep'
import ShopifySyncDialog from '@/modules/integrations/types/shopify/ShopifySyncDialog'

export default Object.freeze({
  type: 'shopify',
  title: 'Integrations_Shopify',
  model: {},
  category: 'Integrations_Shopify_Category',
  description: 'Integrations_Shopify_Description',
  image: require('@/img/integrations/shopify.png'),
  requiresAdmin: false,
  stepped: true,
  components: {
    settings: ShopifySettings,
    overview: ShopifyOverview
  },
  actions: [
    {
      icon: 'el-icon-refresh',
      label: 'Integrations_Shopify_Action_Sync',
      dialog: ShopifySyncDialog
    }
  ],
  urls: {
    guide: 'https://docs.xtremepush.com/docs/shopify'
  },
  steps: [
    {
      name: 'connection',
      title: 'Integrations_Shopify_StepConnection',
      component: ConnectionStep,
      completed: false,
      rules: {
        name: {
          required: true,
          message: 'RestForm_FieldIsRequired'
        },
        params: {
          api_key: {
            required: true,
            message: 'RestForm_FieldIsRequired'
          },
          storefront_url: {
            required: true,
            message: 'RestForm_FieldIsRequired'
          },
          access_token: {
            required: true,
            message: 'RestForm_FieldIsRequired'
          },
          api_secret_key: {
            required: true,
            message: 'RestForm_FieldIsRequired'
          },
          mapping: {
            type: 'array',
            required: true,
            message: 'RestForm_SchemaIsRequired',
            min: 1
          }
        }
      },
      bindProps: {
        autoFetchAttributes: true
      }
    },
    {
      name: 'data_mapping',
      title: 'Automations_Tab_DataMapping',
      component: MappingStep,
      completed: false,
      rules: {
        params: {
          mapping: {
            type: Array,
            min: 1,
            validator: (rule, value, callback) => {
              if (
                value.some(obj => {
                  return obj.attribute === 'user_id'
                })
              ) {
                callback()
              } else {
                callback(new Error())
              }
            }
          }
        }
      },
      params: {
        mapping: []
      }
    },
    {
      name: 'webhooks',
      title: 'Integrations_Shopify_StepWebhooks',
      component: EventsStep,
      completed: false,
      rules: {},
      params: {
        topics: []
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/shopify/index.js